import { useMutation } from '@tanstack/react-query';

import { exchangeToken, refreshToken, RefreshTokenResponse } from '../../api/tokenValidation';

export const useExchangeToken = () =>
  useMutation({
    mutationFn: exchangeToken,
  });

  export const useRefreshToken = () =>
  useMutation<RefreshTokenResponse, Error, string>({
    mutationFn: refreshToken,
  })
